import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { reportDWH } from '../../AddonsBlockSlice';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import successIcon from './images/success-icon.svg';

const SuccessPage = (props) => {

    useEffect(() => {
        switch (props.successType) {
            case 'INSTALL_SERVICE_SUCCESS':
                props.reportDWH({ actionType: 'Purchase Service', status: 'Completed', messageText: 'Success' });
                break;
            case 'INSTALL_MESH_SUCCESS':
                props.reportDWH({ actionType: 'Order MESH', status: 'Completed', messageText: 'Success' });
                break;
            case 'INSTALL_INTERNET_SPEED_SUCCESS':
                props.reportDWH({ actionType: 'Upgrade Speed', status: 'Completed', messageText: 'Success' });
                break;
        }
        gtag4({ event: `Addon_${props.flowType}_Step3_SuccessPage`, step: '3', action: 'SuccessPage', funnel_name: `Addon_${props.flowType}` });
    }, []);

    let title = null;
    let subTitle = null;

    switch (props.successType) {
        case 'INSTALL_SERVICE_SUCCESS':
            title = <> מעולה, סיימנו! </>;
            subTitle = <> <span dangerouslySetInnerHTML={{ __html: props.successPageText }}></span> </>;
            if(props.addonId == 'IPLOCK'){
                subTitle = <> <span dangerouslySetInnerHTML={{ __html: props.successPageText }}></span><span>כתובת ה-IP הקבועה שלך היא <span className='bold'>{props.ipAddress}</span></span> </>;
            }
            // if (props.addonId == '9600NB') {
            //     subTitle = <> מדריך התקנה נשלח למייל שלך, ההתקנה אורכת מספר דקות וניתן להתקין עד 3 מכשירים שונים לבחירתך </>;
            // }
            // else {
            //     subTitle = <> יש לכבות ולהפעיל מחדש את הנתב </>;
            // }
            break;
        case 'INSTALL_MESH_SUCCESS':
            title = <> מעולה! <br /> {props.addon.cmsData?.productNameSelfCare} בדרך אליך </>;
            //subTitle = <> בקרוב נשלח סמס עם מועד הגעת הטכנאי </>;
            subTitle = <> <span dangerouslySetInnerHTML={{ __html: props.successPageText }}></span> </>;
            break;
        case 'INSTALL_INTERNET_SPEED_SUCCESS':
            title = <> מעולה! <br /> המהירות שודרגה בהצלחה </>;
            //subTitle = <> המהירות תתעדכן תוך מספר דקות </>;
            subTitle = <> <span dangerouslySetInnerHTML={{ __html: props.successPageText }}></span> </>;
            break;
        case 'WHATSAPP_SUCCESS':
            title = <> בשניות הקרובות נשלח הודעת WhatsApp לנייד {props.contactNumber} </>;
            break;
        case 'LEAD_SUCCESS':
            title = <> קיבלנו את ההפנייה <br /> ניצור איתך קשר בהתאם לשעות פעילות המוקד </>;
            break;
    }

    return (
        <div className='success-page'>

            <div className='success-icon' style={{backgroundImage:successIcon.bg()}}></div>
            <div className='page-title'> {title} </div>
            <div className='page-sub-title'> {subTitle} </div>

            {
                props.successType == 'INSTALL_MESH_SUCCESS' &&
                <>
                    <div className='technician-details'>
                        <div className='technician-title'> מועד הגעת הטכנאי </div>
                        <div className='technician-datetime'> {props.selectedTechnicianTimeDisplay} </div>
                        <div className='remark'>
                            <span> בזמן ביקור הטכנאי, חייב להיות בבית מבוגר מעל גיל 18 </span>
                        </div>
                    </div>

                    <div className='summary-details'>
                        <div className='summary-row'>
                            <div className='row-title'> יחידות </div>
                            <div className='row-value'> {props.meshList.length} </div>
                        </div>
                        <div className='summary-row'>
                            <div className='row-title'> סה"כ לתשלום </div>
                            <div className='row-value'>
                                <div className='price'> {getTotalPrice()} <span className='nis'>₪</span>&nbsp;<span>לחודש</span> </div>
                                {
                                    false &&
                                    <div className='price-text'> לאחר מכן 125 ₪ לחודש </div>
                                }
                            </div>
                        </div>
                        <div className='bottom-remark'>
                            עלות ההתקנה ע"י הטכנאי הינה
                            {
                                getTechnicianPrice() == 0 ? (
                                    <> ללא עלות </>
                                ) : (
                                    <> {getTechnicianPrice()} ₪ </>
                                )
                            }
                        </div>
                    </div>
                </>
            }

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='סיום'
                    onclick={handleOnContinue}
                    formid='success-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}
                />
            </div>

        </div>
    );

    function getTotalPrice() {
        const total = props.meshList.reduce(function (a, b) {
            return a + parseFloat(b['price']);
        }, 0);
        return parseFloat(total.toFixed(2));
    }

    function getTechnicianPrice() {
        const supplyMethod = props.saleCatalog?.supplyMethods?.find((x) => x.name == 'Technician');
        if (!supplyMethod) { return ''; }
        const price = getPrice(supplyMethod?.price);
        return displayPrice(price);
    }

    function getPrice(price) {
        return (price ? price : 0);
    };

    function displayPrice(price) {
        if (typeof price === 'number') {
            return parseFloat(price.toFixed(2));
        }
        else {
            return parseFloat(parseFloat(price).toFixed(2));
        }
    };

    function handleOnContinue() {
        buildUrlAndOpenSameWindow(Config.selfCareInternetLink);
    }

};

const mapStateToProps = (state) => {
    return {
        addonId: state.addonsBlock.addonId,
        successType: state.addonsBlock.successType,
        flowType: state.addonsBlock.flowType,
        meshList: state.addonsBlock.saleCatalog.addons?.filter((x) => x.name == state.addonsBlock.addonId && x.action == 'Add'),
        selectedTechnicianTimeDisplay: state.addonsBlock.technician.selectedTechnicianTimeDisplay,
        saleCatalog: state.addonsBlock.saleCatalog,
        addon: state.addonsBlock.saleCatalog.addons?.find((x) => x.name == state.addonsBlock.addonId),
        contactNumber: state.authentication?.loginData?.userDetails?.contactNumber,
        successPageText: state.addonsBlock.successPageText,
        ipAddress: state.addonsBlock.ipAddress
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
